// extracted by mini-css-extract-plugin
export default {"root":"Icons_root__gEtXB"};